import { z } from "zod/v4";
import { OcpiDateTime } from "../ocpi.utils";
import { Price } from "./_common";
import { GeoLocation } from "./locations";

export const Terminal = z.object({
  terminal_id: z.string().max(36),
  customer_reference: z.string().max(36).nullish(),
  party_id: z.string().length(3).nullish(),
  country_code: z.string().length(2).nullish(),
  address: z.string().max(45).nullish(),
  city: z.string().max(45).nullish(),
  postal_code: z.string().max(10).nullish(),
  state: z.string().max(20).nullish(),
  country: z.string().length(3).nullish(),
  coordinates: GeoLocation.nullish(),
  invoice_base_url: z.url().nullish(),
  invoice_creator: z.enum(["CPO", "PTP"]).nullish(),
  reference: z.string().max(36).nullish(),
  location_ids: z.array(z.string().max(36)).nullish(),
  evse_uids: z.array(z.string().max(36)).nullish(),
  last_updated: OcpiDateTime,
});

export const Terminals = z.array(Terminal);

export const FinancialAdviceConfirmation = z.object({
  id: z.string().max(36),
  authorization_reference: z.string().max(36),
  total_costs: Price,
  currency: z.string().length(3),
  eft_data: z.array(z.string()),
  capture_status_code: z.enum(["SUCCESS", "PARTIAL_SUCCESS", "FAILED"]),
  capture_status_message: z.string().max(255).nullish(),
  last_updated: OcpiDateTime,
});

export const FinancialAdviceConfirmations = z.array(
  FinancialAdviceConfirmation,
);
